import { request } from "@/api/client";

export type CRMEventRecord = {
  id: string;
  title?: string | null;
  status?: string | null;
  venue?: string | null;
  city?: string | null;
  state?: string | null;
  country?: string | null;
  start_date?: string | null;
  end_date?: string | null;
  workflow_id?: string | null;
  revenue_projection?: number | null;
  cost_projection?: number | null;
  metadata?: Record<string, unknown> | null;
};

export function fetchEventDetail(eventId: string | number): Promise<CRMEventRecord> {
  return request<CRMEventRecord>(`/events/${encodeURIComponent(String(eventId))}`);
}
